<div class="tech-flag-dialog" *ngIf="!isLoading">
  <div class="tech-flag-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="fas fa-flag font-20 header-icon notification-red"
          *ngIf="service?.isTechFlag && service?.techFlag?.flagStatus === 'open'"></i>
        <i class="fas fa-flag font-20 font-gray-35 header-icon"
          *ngIf="service?.isTechFlag && service?.techFlag?.flagStatus === 'resolved'"></i>
        <div class="pl-1 tech-flag-descrption width-100p p-relative">
          <span class="m-0 font-secondary-900 font-14 font-bold">{{ service?.techFlag?.techName }}</span>
          <span class="m-0 font-secondary-900 font-14" *ngIf="techCreatedBy.date"> - {{ this.techCreatedBy.date }}</span>
        </div>
        <i id="flag-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>


  <div class="ui-g tech-flag-body pt-0 pb-0 border-bottom-light">
    <div class="ui-g-12 inputs-column-spacing tech-flag-inner-body">
      <!-- Tech Description -->
      <div class="ui-g-12 p-0 flex-start-center mb-2">
        <div class="icon flex-center-start">
          <i class="fal fa-comment-exclamation height-icon mb-40p"></i>
        </div>

        <div class="width-100p pl-1 ml-1 tech-area-bg">
          <div class="bottom-6p flag-label">
            <span class="font-gray-45 font-11">Tech's error description</span>
          </div>
          <div>
            <app-textarea class="note-text-area width-100" styleClassInput="test" theme="light"
              placeholder="Enter your flag note" [fontSize]="14" [maxAutoGrowHeight]="1000" [maxLength]="2000"
              [rows]="3" [autoGrow]="false" [autoFocus]="false" [value]="service?.techFlag?.techNotes" [disabled]="true"
              (appChange)="handleChange($event)" (appClear)="onNotesClear()">
            </app-textarea>
          </div>


        </div>
      </div>

      <!-- Response  -->
      <div class="ui-g-12 p-0 flex-start-center">
        <div class="icon flex-center-start">
          <i class="fal fa-comment-lines height-icon mb-40p"></i>
        </div>

        <div class="width-100p pl-1 ml-1 response-textarea">
          <div class="bottom-6p flag-label">
            <span class="font-gray-45 font-11">Response</span>
          </div>
          <div>
            <app-textarea class="note-text-area width-100" styleClassInput="test" theme="light"
              placeholder="Enter your flag note" [fontSize]="14" [maxAutoGrowHeight]="1000" [maxLength]="2000"
              [rows]="3" [autoGrow]="false" [autoFocus]="false" [value]="service?.techFlag?.adminNotes"
              [disabled]="service?.techFlag?.flagStatus === 'resolved'" (appChange)="handleChange($event)"
              (appClear)="onNotesClear()">
            </app-textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tech flag Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer part-footer p-0">
    <div class="tech-flag-dialog-footer d-flex justify-content-between width-100p">
      <div>
      </div>
      <div>
        <button class="btn btn-border pointer btn-submit mr-2"
          (click)="handleCloseModal()">{{service?.techFlag?.flagStatus === 'resolved' ? 'Close': 'Cancel'}}</button>
        <button class="btn btn-primary btn-submit mr-2"
          *ngIf="service?.techFlag?.flagStatus !== 'resolved' && service.isTechFlag" (click)="resolveTechFlag()">
          <span [ngClass]="{'pr-2': isProcessingResolved}">Mark as resolved</span>
          <i *ngIf="isProcessingResolved" class="far fa-spinner rotate"></i>
        </button>

        <button class="btn btn-primary btn-submit pointer mr-2"
          [disabled]="service?.techFlag?.flagStatus === 'resolved'"
          *ngIf="service?.techFlag?.flagStatus === 'resolved' && service.isTechFlag">
          <span [ngClass]="{'pr-2': isProcessing}">Resolved</span>
          <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
        </button>

        <button class="btn btn-primary pointer btn-submit" style="height: 31px;"
          [disabled]="service?.techFlag?.flagStatus === 'resolved' || isProcessingSave" (click)="saveTechFlag()">
          <span [ngClass]="{'pr-2': isProcessingSave}">Update</span>
          <i *ngIf="isProcessingSave" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>

</div>
